import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import PrivateRoutes from './components/PrivateRoutes';

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Transactions from "./pages/Transactions";
import SidebarNavigation from './components/SidebarNavigation';
import Index from './pages/Home';
import ManualOrder from './pages/ManualOrder';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsCondition from './pages/TermsCondition';
import Wallet from './pages/Wallet';
import FundTransfer from './pages/FundTransfer';
import Passbook from './pages/Passbook';
import DashboardPayout from './pages/DashboardPayout';
import ResellerDashboard from './pages/ResellerDashboard';
import ResellerTransactions from './pages/ResellerTransactions';
import ResellerDashboardPayout from './pages/ResellerDashboardPayout';
import ResellerPassbook from './pages/ResellerPassbook';

export default function App(){

    const [auth, setAuth] = useState(false);
    const [isRes, setIsRes] = useState(false);
    useEffect(() => {
        sessionStorage.clear();
    },[])

    return (
        <Router>
            <main>
            {auth ? <SidebarNavigation setAuth={setAuth}  isRes={isRes} setIsRes={setIsRes} /> : ''}
            <Routes>
                <Route path='Web/' element={<Index  setAuth={setAuth}/>} /> 
                <Route path='/privacypolicy' element={<PrivacyPolicy setAuth={setAuth} />} /> 
                <Route path='/termscondition' element={<TermsCondition  setAuth={setAuth}/>} /> 
                {/* <Route path='/login' element={<Login setAuth={setAuth} />} />  */}
                {/* <Route element={<PrivateRoutes auth={auth}  setAuth={setAuth}/>}>
                    <Route path='/dashboard' element={<Dashboard setAuth={setAuth}/>}  /> 
                    <Route path='/transactions' element={<Transactions  setAuth={setAuth}/>} /> 
                    <Route path='/transaction' element={<ResellerTransactions  setAuth={setAuth}/>} /> 
                    <Route path='/manualorder' element={<ManualOrder  setAuth={setAuth}/>} /> 
                    <Route path='/wallet' element={<Wallet  setAuth={setAuth}/>} /> 
                    <Route path='/fundtransfer' element={<FundTransfer  setAuth={setAuth}/>} /> 
                    <Route path='/passbook' element={<Passbook  setAuth={setAuth}/>} /> 
                    <Route path='/payoutdashboard' element={<DashboardPayout  setAuth={setAuth}/>} /> 
                    <Route path='/resellerdashboard' element={<ResellerDashboard setIsRes={setIsRes} isRes={isRes} setAuth={setAuth}/>} /> 
                    <Route path='/payout-dashboard' element={<ResellerDashboardPayout setIsRes={setIsRes} isRes={isRes} setAuth={setAuth}/>} /> 
                    <Route path='/RPassbook' element={<ResellerPassbook setIsRes={setIsRes} isRes={isRes} setAuth={setAuth}/>} /> 
                </Route> */}
            </Routes>
            </main>
        </Router>
    )
}